import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const location = useLocation();
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user); // true nếu user tồn tại, false nếu không
    });
    return () => unsubscribe(); // Cleanup
  }, [auth]);

  if (isAuthenticated === null) {
    return <div>Loading...</div>; // Hiển thị loading trong khi kiểm tra auth
  }

  if (!isAuthenticated) {
    // Redirect đến login, lưu URL hiện tại (state) để quay lại sau
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
